module.exports = __webpack_public_path__ + "static/media/Leave3.27cc98e0.svg";